import { Component, Vue } from 'vue-property-decorator'
import { getTranslateValue, langData, lang } from '@/utils/util'

@Component({
  name: 'TranslateMixin'
})
export default class extends Vue {

  protected langData = langData

  public lang = lang

  protected $t (key: string, replace?: any) {
    return getTranslateValue(key, replace)
  }
}
